import { Link } from 'react-router-dom';
import { env } from '@/config/env';

/** App footer: product/version, quick links, and a subtle status affordance. */
export function Footer() {
  return (
    <footer className="border-t border-border px-6 py-4">
      <div className="flex flex-col items-center justify-between gap-3 text-xs text-fg-subtle sm:flex-row">
        <p>© {new Date().getFullYear()} {env.appName}. All rights reserved.</p>
        <nav className="flex items-center gap-4" aria-label="Footer">
          <Link to="/health" className="hover:text-fg-muted">System status</Link>
          <a href="https://docs.nifty-hosting.net" target="_blank" rel="noreferrer" className="hover:text-fg-muted">Documentation</a>
          <a href="https://docs.nifty-hosting.net/api" target="_blank" rel="noreferrer" className="hover:text-fg-muted">API</a>
          <span className="font-mono">v{env.appVersion}</span>
        </nav>
      </div>
    </footer>
  );
}
